export default __webpack_public_path__ + "static/media/Degradado.6f16b47d.ogv";